import React, { useState, useEffect } from "react"
import { Modal, Button, Form, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"

const FileUploadModal = ({ show, onHide, onUpload, fileKinds, fileKindIds: initialFileKindIds }) => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [fileKindId, setFileKindId] = useState("")
  const [uploading, setUploading] = useState(false)

  useEffect(() => {
    if (show) {
      setFileKindId(initialFileKindIds?.length === 1 ? initialFileKindIds[0] : "")
    } else {
      // Reset state when modal is hidden
      setSelectedFile(null)
      setFileKindId("")
      setUploading(false)
    }
  }, [show, initialFileKindIds])

  const handleFileChange = e => {
    const file = e.target.files[0]
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        // 10MB limit
        toast.error("Το μέγεθος του αρχείου δεν μπορεί να υπερβαίνει τα 10MB")
        e.target.value = null
        return
      }
      setSelectedFile(file)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (!selectedFile) {
      toast.error("Παρακαλώ επιλέξτε αρχείο")
      return
    }
    if (fileKinds && !fileKindId) {
      toast.error("Παρακαλώ επιλέξτε τύπο αρχείου")
      return
    }

    setUploading(true)
    try {
      // Convert file to base64
      const reader = new FileReader()
      reader.onload = async () => {
        const base64Data = reader.result.split(",")[1]
        const formData = {
          fileKindId: parseInt(fileKindId, 10),
          fileName: selectedFile.name,
          fileContent: base64Data
        }

        const response = await onUpload(formData)
        if (!response?.data?.IsSuccess) {
          setUploading(false)
        }
      }
      reader.readAsDataURL(selectedFile)
    } catch (err) {
      console.error("Error uploading file:", err)
      toast.error("Αποτυχία ανεβάσματος αρχείου")
      setUploading(false)
    }
  }

  const handleClose = () => {
    setSelectedFile(null)
    setFileKindId("")
    onHide()
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Ανέβασμα Αρχείου</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {fileKinds && (
            <Form.Group className="mb-3">
              <Form.Label>Τύπος Αρχείου</Form.Label>
              <Form.Select
                value={fileKindId}
                onChange={e => setFileKindId(e.target.value)}
                required
                disabled={uploading || initialFileKindIds?.length === 1}
                isInvalid={!fileKindId}>
                <option value="">Επιλέξτε τύπο αρχείου</option>
                {fileKinds.map(kind => (
                  <option key={kind.Code} value={kind.Code}>
                    {kind.Name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <Form.Label>Αρχείο</Form.Label>
            <Form.Control
              type="file"
              onChange={handleFileChange}
              required
              disabled={uploading}
              isInvalid={!selectedFile}
            />
            <Form.Text className="text-muted">Μέγιστο μέγεθος αρχείου: 10MB</Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={uploading}>
            Ακύρωση
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={uploading || !selectedFile || (fileKinds && !fileKindId)}>
            {uploading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Ανέβασμα...
              </>
            ) : (
              <>
                <i className="fas fa-upload me-2" />
                Ανέβασμα
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default FileUploadModal
